import React from "react";

const SvgPisces = (props) => {
  return (
    <svg
      viewBox="0 0 35.67 35.94"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="M34.17 16.47H24.12c.41-5.39 3-10.36 7.26-13.8.65-.52.75-1.46.23-2.11-.52-.64-1.47-.74-2.11-.22-4.97 4.02-7.97 9.83-8.39 16.14h-6.56c-.41-6.3-3.41-12.12-8.39-16.14-.64-.53-1.58-.43-2.1.22-.52.64-.42 1.59.22 2.11 4.26 3.44 6.85 8.41 7.26 13.8H1.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h10.04c-.41 5.39-3 10.36-7.26 13.8-.65.52-.75 1.46-.22 2.11.3.37.73.56 1.17.56.33 0 .66-.11.94-.33 4.97-4.01 7.97-9.83 8.39-16.14h6.56c.41 6.3 3.42 12.12 8.39 16.14.28.22.61.33.94.33.44 0 .87-.19 1.17-.56.52-.64.42-1.59-.23-2.11a19.591 19.591 0 01-7.26-13.8h10.04c.83 0 1.5-.67 1.5-1.5s-.68-1.5-1.5-1.5z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default SvgPisces;
